/* This is the EMIS program for pre grade 1 for primary school components */
<template>
	<v-container>
    <div>
			<span v-html="title"></span>
		</div>
		<div>
      <table style="height: 72px;" border="1px;" width="240px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td style="width: 100px; height: 25px; text-align: center; vertical-align: middle;" rowspan="2">ប្រភេទ</td>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួត</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in f2.length" :key="row">
            <td style="width: 100px; height: 25px; text-align: left; vertical-align: middle;">{{f2[row]}}</td>
            <td v-for="(value, col) in data[row].dt.length" :key="col" class="row-data">
              <numberinput v-model="data[row].dt[col]" class="number"/>
            </td>
          <!-- Total row -->
          <tr>
            <td class="row-header"><strong>សរុប</strong></td>
            <td v-for="(value, col) in totalRow.length" :key="col" class="row-data">
              <strong>{{totalRow[col] | blank}}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from '@/components/common/NumberInput.vue'
import { f2 } from '@/utils/ascf/priConfig.js'
export default {
	props: ["data", "title"],
	components: {
    'numberinput': NumberInput
  },
	data() {
    return {
			f2: f2
    }
  },
  computed: {
		// need to update the total staff in json data
		totalRow: function () {	
			let result
			let d = this.data
			let ldata = this.data.length

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if (ind < ldata) { // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b)
          }
				})
				return r
			}, [])
      return result
		}
  },
  filters: {
		blank: function (value) {
			if (value==0) return ''
			return value
		}
	}
}
</script>

<style scoped>
  .number {
      width:35px;
      text-align: center;
  }
  .row-data {
    width: 35px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
  .row-header {
    width: 70px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
</style>